
var dobbyCartTimer = null;
var dobbyTimerSeconds = 900;

function dobbyCartOpen() {
  var el = document.getElementById('dobby-cart-drawer');
  var overlay = document.getElementById('dobby-cart-overlay');
  if (!el) return;
  overlay.style.display = 'block';
  el.style.right = '0';
  document.body.style.overflow = 'hidden';
  dobbyCartFetch();
  dobbyStartTimer();
}

function dobbyCartClose() {
  var el = document.getElementById('dobby-cart-drawer');
  var overlay = document.getElementById('dobby-cart-overlay');
  if (!el) return;
  el.style.right = '-420px';
  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function dobbyStartTimer() {
  var timerEl = document.getElementById('dobby-cart-timer');
  if (timerEl) timerEl.style.display = 'block';
  if (dobbyCartTimer) clearInterval(dobbyCartTimer);
  dobbyTimerSeconds = 900;
  dobbyCartTimer = setInterval(function() {
    dobbyTimerSeconds--;
    if (dobbyTimerSeconds <= 0) { clearInterval(dobbyCartTimer); dobbyTimerSeconds = 900; }
    var m = Math.floor(dobbyTimerSeconds / 60);
    var s = dobbyTimerSeconds % 60;
    var disp = document.getElementById('dobby-timer-display');
    if (disp) disp.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }, 1000);
}

function dobbyFmtMoney(cents) {
  return (cents / 100).toLocaleString('de-DE', {style:'currency', currency:'EUR'});
}

function dobbyCartFetch() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      var countEl = document.getElementById('dobby-cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      var totalEl = document.getElementById('dobby-cart-total');
      if (totalEl) totalEl.textContent = dobbyFmtMoney(cart.total_price);
      var itemsEl = document.getElementById('dobby-cart-items');
      var emptyEl = document.getElementById('dobby-cart-empty');
      if (cart.item_count === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        if (itemsEl) itemsEl.innerHTML = '<div style="text-align:center;padding:40px 0;color:#999;font-size:14px;">Dein Warenkorb ist leer.</div>';
        return;
      }
      if (emptyEl) emptyEl.style.display = 'none';
      var savings = 0;
      cart.items.forEach(function(item) {
        if (item.compare_at_price > item.price) savings += (item.compare_at_price - item.price) * item.quantity;
      });
      var savRow = document.getElementById('dobby-savings-row');
      var savAmt = document.getElementById('dobby-savings-amount');
      if (savings > 0 && savRow && savAmt) {
        savRow.style.display = 'flex';
        savAmt.textContent = dobbyFmtMoney(savings);
      }
      var html = '';
      cart.items.forEach(function(item) {
        html += '<div style="display:flex;gap:14px;align-items:flex-start;">';
        html += '<img src="' + item.image + '" style="width:72px;height:72px;border-radius:8px;object-fit:cover;flex-shrink:0;" loading="lazy">';
        html += '<div style="flex:1;min-width:0;">';
        html += '<div style="font-size:14px;font-weight:600;color:#121212;line-height:1.3;margin-bottom:4px;">' + item.product_title + '</div>';
        html += '<div style="font-size:12px;color:#777;margin-bottom:8px;">' + item.variant_title + '</div>';
        html += '<div style="display:flex;align-items:center;justify-content:space-between;">';
        html += '<div style="display:flex;align-items:center;gap:8px;">';
        html += '<button onclick="dobbyCartUpdate(\'' + item.key + '\',' + (item.quantity-1) + ')" style="width:26px;height:26px;border:1px solid #e0e0e0;background:#fff;border-radius:6px;cursor:pointer;font-size:16px;">&#8722;</button>';
        html += '<span style="font-size:14px;font-weight:600;">' + item.quantity + '</span>';
        html += '<button onclick="dobbyCartUpdate(\'' + item.key + '\',' + (item.quantity+1) + ')" style="width:26px;height:26px;border:1px solid #e0e0e0;background:#fff;border-radius:6px;cursor:pointer;font-size:16px;">+</button>';
        html += '</div>';
        if (item.compare_at_price > item.price) {
          html += '<div style="text-align:right;"><div style="font-size:11px;color:#aaa;text-decoration:line-through;">' + dobbyFmtMoney(item.compare_at_price * item.quantity) + '</div><div style="font-size:15px;font-weight:700;">' + dobbyFmtMoney(item.final_line_price) + '</div></div>';
        } else {
          html += '<div style="font-size:15px;font-weight:700;">' + dobbyFmtMoney(item.final_line_price) + '</div>';
        }
        html += '</div></div></div>';
      });
      if (itemsEl) itemsEl.innerHTML = html;
    });
}

function dobbyCartUpdate(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: qty})
  }).then(function(){ dobbyCartFetch(); });
}

document.addEventListener('DOMContentLoaded', function() {
  // Update cart count
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
    var el = document.getElementById('dobby-cart-count');
    if (el) el.textContent = cart.item_count;
  });

  // Intercept cart links
  function hookCartLinks() {
    document.querySelectorAll('a[href="/cart"]').forEach(function(el) {
      if (!el.dataset.dobbyHooked) {
        el.dataset.dobbyHooked = '1';
        el.addEventListener('click', function(e) {
          e.preventDefault();
          dobbyCartOpen();
        });
      }
    });
  }
  hookCartLinks();
  setTimeout(hookCartLinks, 1000);

  // Intercept ATC form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', {method: 'POST', body: data})
        .then(function(r){ return r.json(); })
        .then(function(){ dobbyCartOpen(); })
        .catch(function(){ window.location.href = '/cart'; });
    }
  });
});
